module.exports = __webpack_public_path__ + "img/intro_s1.2ce0b475.png";